var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " globe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.617 19.552C15.666 18.054 16.757 15.851 16.975 13H19.93C19.547 16.052 17.441 18.57 14.617 19.552ZM4.069 13H7.061C7.267 15.862 8.344 18.056 9.407 19.561C6.57 18.584 4.454 16.061 4.069 13ZM9.438 4.429C8.386 5.927 7.285 8.137 7.065 11H4.069C4.455 7.928 6.586 5.397 9.438 4.429ZM9.079 11C9.385 7.728 11.059 5.45 12.026 4.397C13.026 5.468 14.674 7.725 14.959 11H9.079ZM9.08 13H14.962C14.656 16.277 12.978 18.555 12.012 19.608C10.965 18.498 9.359 16.272 9.08 13ZM19.93 11H16.978C16.773 8.151 15.708 5.964 14.65 4.461C17.458 5.451 19.549 7.96 19.93 11ZM22 12C22 6.496 17.529 2.018 12.028 2.002C12.024 2.002 12.02 2.001 12.015 2.001C12.011 2.001 12.005 2 12 2C6.486 2 2 6.487 2 12C2 17.514 6.486 22 12 22C12.006 22 12.011 21.999 12.015 21.999C12.017 21.999 12.018 22 12.02 22C12.023 22 12.026 21.998 12.028 21.998C17.529 21.983 22 17.504 22 12Z",
    fill: "#717171"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/Globe.04fb99a448b0031e305f16d4047b2564.svg";
export { ForwardRef as ReactComponent };